<template>
  <ValidationProvider
    v-slot="{ errors, required }"
    tag="div"
    class="grid grid-cols-12"
    :rules="rules"
  >
    <div class="col-span-12 md:col-span-3">
      <div class="label">
        <input-label
          :error="errors[0]"
          :text="`${label}${required ? ' *' : ''}`"
        />
      </div>
    </div>

    <div class="col-span-12 md:col-span-6">
      <div class="flex gap-2 items-center justify-start">
        <div class="flex items-center">
          <t-toggle
            v-model="isChecked"
            :variant="`regular`"
            :checked="isChecked"
          />
        </div>
        <span class="text-sm font-medium">{{ getStatusText }}</span>
      </div>

      <p
        v-if="showDescription"
        :class="{ 'text-red-500': errors[0] }"
        class="description mb-2"
      >
        {{ description }}
      </p>
    </div>
  </ValidationProvider>
</template>

<script>
import InputLabel from '@/components/form/InputLabel'

export default {
  name: 'SmartToggleInput',
  components: {
    InputLabel,
  },
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    showDescription: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    onText: {
      type: String,
      default: '',
    },
    offText: {
      type: String,
      default: '',
    },
    onValue: {
      type: [Boolean, String],
      default: true,
    },
    offValue: {
      type: [Boolean, String],
      default: false,
    },
    value: {
      type: [Boolean, String],
      default: false,
    },
  },

  data() {
    return {
      isChecked: false,
    }
  },

  computed: {
    getStatusText() {
      return this.isChecked ? this.onText : this.offText
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // Convert string or boolean to boolean for toggle state
        this.isChecked = newVal === this.onValue
      },
    },
    isChecked(newVal) {
      const emittedValue = newVal ? this.onValue : this.offValue
      this.$emit('input', emittedValue)
      this.$emit('save', emittedValue)
    },
  },
}
</script>

<style lang="scss">
.description {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>
